import ServicePage from '../components/service/ServicePage'

export default function TamponBaski() {
  return <ServicePage service="pad" lang="tr" />
}
